import type {
  ListingGalleryAsset,
  ListingVisualsSection,
} from "../../../../types/listing-wizard.types";

/** Remove gallery entries that reference a deleted mockup (by URL and/or scoped id). */
export function removeGalleryItemsByMockupRef(
  gallery: ListingGalleryAsset[],
  ref: { url: string; id?: string; productId?: string }
): ListingGalleryAsset[] {
  return gallery.filter((item) => {
    const matchesUrl = item.url === ref.url;
    const matchesId = ref.id ? item.id === ref.id : false;
    if (!matchesUrl && !matchesId) return true;
    if (ref.productId && item.productId && item.productId !== ref.productId) {
      return true;
    }
    return false;
  });
}

/** Remove all gallery entries for a catalog product. */
export function removeGalleryItemsForProduct(
  gallery: ListingGalleryAsset[],
  productId: string
): ListingGalleryAsset[] {
  return gallery.filter((item) => item.productId !== productId);
}

export function purgeVisualsForDeletedMockup(
  visuals: ListingVisualsSection,
  ref: { url: string; id?: string; productId?: string }
): ListingVisualsSection {
  return {
    ...visuals,
    gallery: removeGalleryItemsByMockupRef(visuals.gallery ?? [], ref),
  };
}

export function purgeVisualsForRemovedProduct(
  visuals: ListingVisualsSection,
  productId: string
): ListingVisualsSection {
  return {
    ...visuals,
    gallery: removeGalleryItemsForProduct(visuals.gallery ?? [], productId),
    galleryAutoSeededProductIds: (
      visuals.galleryAutoSeededProductIds ?? []
    ).filter((id) => id !== productId),
  };
}
